// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest, getNoBaseRequest } from '@/libs/axios';


// 分页获取消息信息
export const _getByPage = (params) => {
    return postRequest('/copyrightRegisterDci/getByPage', params)
};

// // 获取登记详情信息
// export const _getDetail = (params) => {
//     return getRequest('/copyrightregister/getDetail', params)
// };

// 获取登记详情信息
export const _getDetail = (params) => {
    return getRequest('/copyrightRegisterDci/getDetail', params)
};

//版权登记 POST /bqjvip/copyrightRegisterDci/save
export const _save = (params) => {
    return postRequest('/copyrightRegisterDci/save', params)
};
//POST /bqjvip/copyrightRegisterDci/reSubmit
export const _resubmit = (params) =>{
    return postRequest('/copyrightRegisterDci/reSubmit',params)
}

//作品类型
export const _getWorksTypeCopyright = (params) => {
    return getNoBaseRequest('/bqjvip/config/getWorksTypeList2', params)
}